import { useEffect, useState } from 'react'

export const useHasJS = () => {
  const [hasJS, setHasJS] = useState(false)

  useEffect(() => {
    setHasJS(true)
  }, [])

  return hasJS
}
